<template>
  <div class="fh-update-fields">
    <!--  引用字段 -->
    <template v-if="fieldType == 21">
      <reference :params="getReferenceConfig" :clickType="1" />
    </template>
    <!-- 普通字段 -->
    <template v-else>
      <component v-if="components" :is="components" v-bind="componentProps" @cb="cb" @selectPopVisibleCb="selectPopVisibleCb" @personDepartCb="personDepartCb" @attachMentCb="getFiles" />
    </template>
    <!-- 计算字段错误信息 -->
    <jw-tooltip v-if="errorDataMap && errorDataMap[modulesItem?.setting?.fieldKey]" :content="errorDataMap[modulesItem?.setting?.fieldKey]">
      <icon-exclamation-circle-fill :size="16" />
    </jw-tooltip>
  </div>
</template>

<script setup>
import { onMounted, ref, computed, provide } from 'vue';
import { cloneDeep } from 'lodash';

import { tools } from '@/utils/tools.js';
import useViewFields from '@/hooks/view-fields';
import Assiciation from './components/association/association.vue';
import Attachment from './components/attachment/attachment.vue';
import Cascader from './components/cascader/cascader.vue';
import DateCmp from './components/date/date-cmp.vue';
import DateRangeCmp from './components/date-range/date-range.vue';
import NumberCmp from './components/number/number.vue';
import Percent from './components/percent/percent.vue';
import Person from './components/person/person.vue';
import Price from './components/price/price.vue';
import Depart from './components/depart/depart.vue';
import RadioCmp from './components/radio/radio.vue';
import RichText from './components/rich-text/rich-text.vue';
import SelectCmp from './components/select/select.vue';
import TextCmp from './components/text/text.vue';
import Textarea from './components/text-area/text-area.vue';

import reference from '../../../fh-set-fields/components/reference/reference.vue'; //引用字段
import { emptyText } from '@/utils/const';

const { getDept, departmentList } = useViewFields();

const props = defineProps({
  modules: {
    //接收的数据
    type: Object,
    default: () => {}
  },
  formatData: {
    type: Array,
    default: () => []
  },
  from: {
    //布局type
    // 20 ：字段  30 ：关联表格 35 ：子表单
    type: Number || String,
    default: () => 20
  },
  opType: {
    //操作类型
    // 0 普通编辑  1 表格行内编辑
    type: Number || String,
    default: () => 0
  },
  rowIndex: {
    //子表单中记录编辑的是第几行
    type: Number || String,
    default: () => ''
  },
  //30:新增 40：编辑
  type: {
    type: Number || String,
    default: 30
  },
  mainForm: {
    //主表数据
    type: Array,
    default: () => []
  },
  popupContainer: {
    //元素挂载节点支持配置，兼容部分场景中查找关联被遮盖所以可自行挂载到body下
    type: String,
    default: ''
  },
  entity: {
    type: Number || String,
    default: null
  },
  errorDataMap: {
    // 计算字段错误信息
    type: Object
  },
  singleFieldEdit: {
    type: Boolean,
    default: false
  },
  disabledAll: {
    type: Boolean,
    default: false
  },
  formDisabled: {
    type: Boolean,
    default: false
  }
});

const modulesItem = ref(props?.modules);
const selectList = [2, 3, 4, 5]; //选项类
const dataForm = ref(props.formatData);
const fieldType = computed(() => props.modules?.setting?.fieldType); // 数据类型
const componentMap = {
  0: TextCmp, //单行文本
  1: Textarea, // 多行文本
  2: SelectCmp, // 单选
  3: SelectCmp, // 多选
  4: SelectCmp, // 下拉单选选
  5: SelectCmp, // 下拉多选
  6: Person, // 人员
  7: NumberCmp, // 数字
  8: DateCmp, // 日期
  9: DateRangeCmp, // 日期范围
  10: Cascader, // 级联
  11: TextCmp, //超链接
  12: Assiciation, // 查找关联
  13: TextCmp, // 编码
  16: Price, // 金额
  18: Attachment, // 附件
  22: Depart, // 部门
  23: Percent, // 百分比
  25: Assiciation, // 查找关联
  26: RichText, // 富文本
  30: RadioCmp // 单选 & 多选
};
// 获取引用字段的配置
const getReferenceConfig = computed(() => {
  const getSetting = props.modules?.setting;
  const fieldType = getSetting?.business?.fieldType;
  const fieldExt = getSetting?.business?.fieldExt;
  const referenceConfig = {
    col: { ...getSetting },
    row: props.modules,
    fieldKey: getSetting?.fieldKey,
    mainField: false,
    isRequired: 0,
    fieldValue: props.modules?.fieldValue,
    fieldType: fieldType,
    fieldExt: fieldExt,
    fieldName: getSetting.fieldName,
    sourceType: 2,
    entity: props.entity,
    isSubForm: false,
    permissions: 0
  };
  return referenceConfig;
});
const componentProps = computed(() => ({
  modules: props.modules,
  disabledAll: props.disabledAll,
  formDisabled: props.formDisabled,
  popupContainer: props.popupContainer,
  formatData: props.formatData,
  singleFieldEdit: props.singleFieldEdit,
  opType: props.opType,
  from: props.from,
  mainForm: props.mainForm
}));

const emits = defineEmits(['cb', 'selectPopVisibleCb']);

const cb = (moduleValue) => {
  emits('cb', '', moduleValue, props.rowIndex);
};
const selectPopVisibleCb = (moduleValue) => {
  emits('selectPopVisibleCb', '', moduleValue, props.rowIndex);
};

// 获取文件列表
const getFiles = (files) => {
  // const currentFormData = cloneDeep(props.formatData);

  let fileModuleItem = null;

  const filesList = [];
  files &&
    files.length > 0 &&
    files?.forEach((v) => {
      if (v?.response?.code == 0 && v.response?.data) {
        const url = v.response?.data;
        filesList.push(...url);
      }
      if (v.default) {
        //默认的附件
        filesList.push({ name: v.name, url: v.url });
      }
    });
  dataForm.value?.forEach((item) => {
    if (props.from == 30 || props.from == 35) {
      //明细行或者子表单
      if (item.type == 20 && item?.setting.fieldKey == props.modules?.setting.fieldKey) {
        item.fieldValue = filesList && filesList?.length > 0 ? filesList : null;
        item.filesList = files; //新增一个变量 存储所有的文件列表（包含上传未成功，上传中等）
        fileModuleItem = cloneDeep(item);
      }
      if (item.type == 35) {
        //关联表格里的子表
        item?.modules?.forEach((el) => {
          if (el?.setting.fieldKey == props.modules?.setting.fieldKey) {
            el.fieldValue = filesList && filesList?.length > 0 ? filesList : null;
            el.filesList = files; //新增一个变量 存储所有的文件列表（包含上传未成功，上传中等）
            fileModuleItem = cloneDeep(el);
          }
        });
      }
    } else {
      if (item?.modules) {
        item?.modules.forEach((list) => {
          if (list.type == 20 && list?.setting.fieldKey == props.modules?.setting.fieldKey) {
            list.fieldValue = filesList && filesList?.length > 0 ? filesList : null;
            list.filesList = files; //新增一个变量 存储所有的文件列表（包含上传未成功，上传中等）
            fileModuleItem = cloneDeep(list);
          }
        });
      }
    }
  });

  emits('cb', dataForm.value, fileModuleItem, props.rowIndex);
};

// 人员 部门 回调
const personDepartCb = async (v) => {
  // const currentFormData = cloneDeep(props.formatData);
  let fileModuleItem = null;
  const userDepartNames = fieldType.value === 6 ? computed(() => v?.userList?.map((u) => u.userName)) : computed(() => v?.departList?.map((u) => u.departmentName));
  const departListIDs = fieldType.value === 22 ? v.departList?.map((u) => u.id) : [];
  const userIDs = fieldType.value === 6 ? v.userList?.map((u) => u.id) : [];
  if (props.modules?.setting?.fieldKey == 'chargePerson' || props.modules?.setting?.fieldKey == 'followUser') {
    //线索是跟进人
    //针对负责人和部门做特殊处理
    await getDept({
      departmentId: departListIDs,
      userId: userIDs
    });
  }
  if (userDepartNames.value) {
    dataForm.value?.forEach((item) => {
      if (props.from == 30 || props.from == 35) {
        //关联表格或者子表单
        if (item.type == 20) {
          if (item.value == props.modules?.value) {
            item.fieldValue = userDepartNames.value;
            item.setting.fv = v;
            fileModuleItem = cloneDeep(item);
          }
        }
        if (item.type == 35) {
          //关联表格里的子表
          item?.modules?.forEach((el) => {
            if (el?.setting?.fieldKey == props.modules?.value) {
              el.fieldValue = userDepartNames.value;
              el.setting.fv = v;
              fileModuleItem = cloneDeep(el);
            }
          });
        }
      } else {
        if (item?.modules && item?.modules?.length) {
          item?.modules.forEach((list) => {
            if (list.type == 20) {
              if (list.value == props.modules?.value) {
                list.fieldValue = userDepartNames.value;
                list.setting.fv = v;
                fileModuleItem = cloneDeep(list);
              }
              if (props.modules?.value == 'chargePerson' || props.modules?.value == 'followUser') {
                //修改负责人时更新部门信息
                if (list.value == 'departmentIds') {
                  list.fieldValue = departmentList.value && departmentList.value[0]?.name ? [departmentList.value[0]?.name] : [];
                  list.setting.fv = {
                    departList:
                      departmentList.value && departmentList.value[0]?.name
                        ? [
                            {
                              departmentName: departmentList.value[0]?.name,
                              id: departmentList.value[0]?.id
                            }
                          ]
                        : []
                  };
                  fileModuleItem = cloneDeep({ ...list, changeFieldKey: props.modules?.value });
                }
              }
            }
          });
        }
      }
    });
  }

  emits('cb', dataForm.value, fileModuleItem, props.rowIndex);
};

// 获取字段扩展配置
const getFieldExtType = (fieldExt) => {
  return tools.isJSON(fieldExt) ? JSON.parse(fieldExt)?.type : null;
};

// 根据字段类型获取对应组件
const getComponentByFieldType = (fieldType) => {
  const typeComponentMap = {
    '5,7': 7, // 数字
    '6,16': 16, // 金额
    8: 8, // 日期
    23: 23 // 百分比
  };

  for (const [types, component] of Object.entries(typeComponentMap)) {
    if (types.split(',').map(Number).includes(fieldType)) {
      return componentMap[component];
    }
  }

  return componentMap[0]; // 默认返回文本组件
};

const initComponents = () => {
  const fieldSetting = props.modules?.setting; // 数据设置信息

  // 选项类型处理
  if (selectList.includes(fieldType.value)) {
    if (props.from === 35) return SelectCmp; // 子表单使用下拉单选

    // 选项少于5个时使用单选按钮
    const options = JSON.parse(fieldSetting?.fieldExt || '[]');
    if ([2, 3].includes(fieldType.value) && options?.length <= 5) {
      return RadioCmp;
    }

    return SelectCmp;
  }

  // 计算类型
  if (fieldType.value === 24) {
    const fieldExtType = getFieldExtType(fieldSetting?.fieldExt);
    return getComponentByFieldType(fieldExtType);
  }

  return componentMap[fieldType.value];
};

const fieldPlaceHolder = {
  21: emptyText,
  24: emptyText
};

const isQuoteField = computed(() => {
  if (fieldType.value == 24) {
    return true;
  }
  return false;
});

const quoteFieldPlaceholder = computed(() => {
  if (isQuoteField.value) {
    return fieldPlaceHolder[fieldType.value];
  }
  return null;
});

const components = ref(null);
onMounted(() => {
  components.value = initComponents(); // 获取具体分支
});

provide('fhFormFieldsParams', {
  isQuoteField,
  quoteFieldPlaceholder
});
</script>

<style scoped lang="less">
@import './fh-update-fields.less';
</style>
